import { render, staticRenderFns } from "./StandardPieChart.vue?vue&type=template&id=f9854be4"
import script from "./StandardPieChart.vue?vue&type=script&lang=js"
export * from "./StandardPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports